import React from 'react';
import {
  Card,
} from "tea-component";
import { useIntl } from 'umi';
import { getImg } from '@/pages/home/_config/getImgs';

export default function MobileDataBrain(props: any) {
  const { formatMessage } = useIntl() // 中英切换方法

  return (
    <Card className='home-card'>
      <Card.Body title={
        <div className='home-table-title'>
          {formatMessage({ id: 'dbh_mobiledataBrain_title' })}
        </div>}
      >
        <img src={getImg('erweima')} className='erweima-img' />
        <div className='erweima-text'>
          {formatMessage({ id: 'dbh_mobiledataBrain_desc' })}
        </div>
      </Card.Body>
    </Card>
  );
};
